import { render, staticRenderFns } from "./registration-active.vue?vue&type=template&id=11007fbe&scoped=true"
import script from "./registration-active.vue?vue&type=script&lang=js"
export * from "./registration-active.vue?vue&type=script&lang=js"
import style0 from "./registration-active.vue?vue&type=style&index=0&id=11007fbe&prod&scoped=true&lang=css"
import style1 from "./registration-active.vue?vue&type=style&index=1&id=11007fbe&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11007fbe",
  null
  
)

export default component.exports